import { setDocTitle } from "../../../functions/HelperFuncs";

export default {
  /*
      Defines the data used by the component
    */
  data() {
    return {
      company: this.$store.state.company,
    };
  },
  created() {
    setDocTitle("404", this);
  },
  mounted() {
    history.pushState(null, null, location.href);
    window.onpopstate = function () {
      history.go(1);
    };
  },
};
